import { useCallback } from 'react';
import { css, useTheme } from 'styled-components';

import { Tooltip, POSITIONS } from '@hivebrite/design-system/Tooltip';

import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import ToolbarItem from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarItem';

const LeftIcon = (props) => (
  <svg {...props} width="20px" height="20px" viewBox="0 0 20 20">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="bg" x="0" y="0" width="20" height="20" />
      <rect fill="currentColor" x="2" y="4" width="16" height="2" rx="1" />
      <rect fill="currentColor" x="2" y="14" width="16" height="2" rx="1" />
      <rect fill="currentColor" x="2" y="9" width="11" height="2" rx="1" />
    </g>
  </svg>
);
const CenterIcon = (props) => (
  <svg {...props} width="20px" height="20px" viewBox="0 0 20 20">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="bg" x="0" y="0" width="20" height="20" />
      <rect fill="currentColor" x="2" y="4" width="16" height="2" rx="1" />
      <rect fill="currentColor" x="2" y="14" width="16" height="2" rx="1" />
      <rect fill="currentColor" x="4" y="9" width="12" height="2" rx="1" />
    </g>
  </svg>
);
const RightIcon = (props) => (
  <svg {...props} width="20px" height="20px" viewBox="0 0 20 20">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="bg" x="0" y="0" width="20" height="20" />
      <rect fill="currentColor" x="2" y="4" width="16" height="2" rx="1" />
      <rect fill="currentColor" x="2" y="14" width="16" height="2" rx="1" />
      <rect fill="currentColor" x="7" y="9" width="11" height="2" rx="1" />
    </g>
  </svg>
);

const Align = ({ onItemClick, value, css: baseCss, ...otherProps }) => {
  const theme = useTheme();
  const { quillRef } = useQuillEditorContext();

  const handleToggleValue = useCallback(
    (alignment) => () => {
      quillRef.current.format(
        'align',
        value === alignment ? null : alignment,
        'user',
      );
      onItemClick();
    },
    [value],
  );

  const commonCss = `
    color: ${theme.colors.white} !important;
    margin-left: 0;
    padding: ${theme.space[1]}px;
    height: 24px;
    width: 24px;

    &:hover {
      background-color: ${theme.colors.builder.toolbar.itemHover};
    }
  `;

  return (
    <>
      <Tooltip initialPosition={POSITIONS.BOTTOM} childrenElement={__('Left')}>
        <ToolbarItem
          isActive
          icon={LeftIcon}
          onClick={handleToggleValue('')}
          {...otherProps}
          // TODO: Remove when new Builder Toolbar
          css={css`
            ${commonCss}
            background-color: ${value === ''
              ? theme.colors.builder.toolbar.itemHover
              : undefined};
          `}
        />
      </Tooltip>
      <Tooltip
        initialPosition={POSITIONS.BOTTOM}
        childrenElement={__('Center')}
      >
        <ToolbarItem
          isActive
          icon={CenterIcon}
          onClick={handleToggleValue('center')}
          {...otherProps}
          // TODO: Remove when new Builder Toolbar
          css={css`
            ${commonCss}
            background-color: ${value === 'center'
              ? theme.colors.builder.toolbar.itemHover
              : undefined};
          `}
        />
      </Tooltip>
      <Tooltip initialPosition={POSITIONS.BOTTOM} childrenElement={__('Right')}>
        <ToolbarItem
          isActive
          icon={RightIcon}
          onClick={handleToggleValue('right')}
          {...otherProps}
          // TODO: Remove when new Builder Toolbar
          css={css`
            ${commonCss}
            background-color: ${value === 'right'
              ? theme.colors.builder.toolbar.itemHover
              : undefined};
          `}
        />
      </Tooltip>
    </>
  );
};

Align.getFormat = (format) => format?.align || '';

export default Align;
